/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const updateLikeProductRequestSchema = z.object({
	product_id: z.uuid(),
	liked: z.boolean(),
});
